<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Remix Icon" pageTitle="Remix Icon" />
            <RemixIcon />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import RemixIcon from '../RemixIcon/RemixIcon'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'RemixIconPage',
    components: {
        MainHeader,
        PageTitle,
        RemixIcon,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>